import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    let _this = this;
    setTimeout(()=> {
      _this.element.classList.add('c-details-overlay--open');
    }, 500)
  }
}